import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <Link to="/" className="flex items-center gap-2 text-xl font-heading font-bold text-primary-400 mb-4 whitespace-nowrap">
                <i className="ri-book-open-line w-7 h-7 flex items-center justify-center"></i>
                h漫画
              </Link>
              <p className="text-sm text-foreground-400 leading-relaxed">
                专为成熟读者打造的在线漫画阅读平台，为您提供最优质的h漫画阅读体验。
              </p>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-foreground-100 mb-4 text-sm">漫画分类</h4>
              <div className="flex flex-col gap-2.5">
                <Link to="/category/japanese" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  日系h漫画
                </Link>
                <Link to="/category/chinese" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  国产h漫画
                </Link>
                <Link to="/category/korean" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  韩国h漫画
                </Link>
              </div>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-foreground-100 mb-4 text-sm">快速链接</h4>
              <div className="flex flex-col gap-2.5">
                <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  首页
                </Link>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  关于我们
                </Link>
                <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  隐私政策
                </a>
                <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">
                  服务条款
                </a>
              </div>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-foreground-100 mb-4 text-sm">联系我们</h4>
              <div className="flex flex-col gap-2.5 text-sm text-foreground-400">
                <p>邮箱：contact@hmanga.com</p>
                <p>客服QQ：1234567890</p>
                <p>工作时间：周一至周日 9:00-22:00</p>
              </div>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-foreground-800/30">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs text-foreground-500">
                © 2026 h漫画 版权所有 | 本站内容仅供18岁以上成年人阅读
              </p>
              <div className="flex items-center gap-4 text-xs text-foreground-500">
                <a href="#" className="hover:text-primary-400 transition-colors whitespace-nowrap">隐私政策</a>
                <a href="#" className="hover:text-primary-400 transition-colors whitespace-nowrap">服务条款</a>
                <a href="#" className="hover:text-primary-400 transition-colors whitespace-nowrap">免责声明</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}